// Imagenes pegadas dentro de un correo. El texto plano trae una marca donde iba cada una: Gmail pone
// "[image: foto.png]", Outlook "[cid:image001.png@01DA...]" y Zammad (al pasar el HTML a texto) "[cid:...]". Aqui se
// decide que imagen va en cada marca: por Content-ID si lo hay; si no, por nombre, en el orden del correo (Gmail
// llama "image.png" a todas las que se pegan).
export const MARCA_IMAGEN = /\[(?:image:\s*([^\]]+?)|cid:\s*([^\]\s]+))\s*\]/gi;

type Img = { parte: string; nombre: string; cid?: string | null };

const norm = (s?: string | null) => String(s ?? '').trim().toLowerCase();

// Una entrada por marca, en orden: la imagen que le toca o null.
export function ubicarImagenes<A extends Img>(texto: string, imagenes: A[]): (A | null)[] {
  const usadas = new Set<string>();
  const libre = (f: (a: A) => boolean) => imagenes.find((a) => !usadas.has(a.parte) && f(a)) ?? null;
  return [...texto.matchAll(MARCA_IMAGEN)].map((m) => {
    const nombre = norm(m[1]);
    const cid = norm(m[2]);
    const a = cid ? (libre((x) => norm(x.cid) === cid) ?? libre((x) => norm(x.nombre) === cid.split('@')[0])) : libre((x) => norm(x.nombre) === nombre);
    if (a) usadas.add(a.parte);
    return a;
  });
}

// Partes de las imagenes que quedan dentro del texto (para no repetirlas abajo).
export const partesEnLinea = (texto: string, imagenes: Img[]) => new Set(ubicarImagenes(texto, imagenes).flatMap((a) => (a ? [a.parte] : [])));
